export const priorityDevelopmentAreas = [
  'Ensley',
  'Lomb-Tuscaloosa',
  'Eight Ave',
  'North Birmingham',
  'Woodlawn',
  'East Lake',
  'Downtown Northwest',
  'Forth Ave',
  'Downtown West',
  ' Not Applicable',
];
